var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_601_11330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 13,
    width: 15,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74609 13.3594H17.606V19.8116H3.74609V13.3594Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_601_11330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.677 14.6719C6.94859 14.6719 5.05859 15.3124 5.05859 16.5768C5.05859 17.8525 6.94859 18.4991 10.677 18.4991C14.4045 18.4991 16.2936 17.8586 16.2936 16.5942C16.2936 15.3185 14.4045 14.6719 10.677 14.6719ZM10.677 19.8116C8.96284 19.8116 3.74609 19.8116 3.74609 16.5768C3.74609 13.6928 7.70197 13.3594 10.677 13.3594C12.3911 13.3594 17.6061 13.3594 17.6061 16.5942C17.6061 19.4783 13.6511 19.8116 10.677 19.8116Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_601_11330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03125 2.42578H15.3238V11.7171H6.03125V2.42578Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_601_11330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6784 3.67528C8.80503 3.67528 7.28078 5.19866 7.28078 7.07203C7.27465 8.93928 8.78753 10.4618 10.653 10.4688L10.6784 11.0935V10.4688C12.5509 10.4688 14.0743 8.94453 14.0743 7.07203C14.0743 5.19866 12.5509 3.67528 10.6784 3.67528ZM10.6784 11.7174H10.6504C8.09365 11.7095 6.02253 9.62441 6.03128 7.06941C6.03128 4.51003 8.11553 2.42578 10.6784 2.42578C13.2404 2.42578 15.3238 4.51003 15.3238 7.07203C15.3238 9.63403 13.2404 11.7174 10.6784 11.7174Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.7f9cdc3be9c2b556bb46d7a23e6141d0.svg";
export { ForwardRef as ReactComponent };